module.exports = __webpack_public_path__ + "img/ic-wallet.b68b89e6.png";